import { render, staticRenderFns } from "./WarrantiedSales.vue?vue&type=template&id=03b2d313&"
import script from "./WarrantiedSales.vue?vue&type=script&lang=js&"
export * from "./WarrantiedSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports